<template lang="pug">
  .white.rc-products.fill-height(v-rc-loader="!loaded")
    v-layout.products-wrapper(v-if="parentProducts.length")
      v-flex.xs3.mb-4.lg2.scroll-y-overflow.elevation-1.align-self-start(style="margin-top: 49px;")
        v-list.py-0(:two-line="isRc")
          v-list-tile.product-tile(
            v-for="product in parentProducts"
            :key="product.id"
            @click="selectedProduct = product.name"
            :class="{ 'selected-product': selectedProduct === product.name}"
            )
              v-list-tile-content
                v-list-tile-title {{ product.name }}
                v-list-tile-sub-title(v-if="isRc") {{ formatCurr(getTotalPrice(product.name)) }} H.T./mois
          v-list-tile.grey.lighten-1(v-if="isRc")
            v-list-tile-content
              v-list-tile-title Total
              v-list-tile-sub-title Mensuel : {{ formatCurr(getTotalPrice()) }} H.T.
              v-list-tile-sub-title Annuel : {{ formatCurr(getTotalPrice()*12) }} H.T.
      v-flex.xs9.lg10.scroll-y-overflow.pl-4.pr-1.pb-1.mb-4.align-self-baseline(v-if="selectedProduct")
        rc-table.products-table.elevation-2.mb-4(
          v-if="setHierarchy(products[selectedProduct]).length"
          ref="productTable"
          @recall="getData"
          :items="setHierarchy(products[selectedProduct])"
          :headers="headers"
          :loading="loading"
          :showPagination="false"
          :deleteAction="false"
          :clickToVisit="false"
          :displayFilters="false"
          :displaySortable="clientId === 'all'"
        )
          template(slot="footer")
            v-layout.justify-end.grey.lighten-1.subheading.py-2.px-4(v-if="selectedProduct")
              |TOTAL : {{ formatCurr(getTotalPrice(selectedProduct)) }} H.T./mois
        .elevation-2(v-if="selectedReferents.length")
          .title.table-header.text--darken-1.grey--text.py-3.px-4 Contact{{ selectedReferents.length > 1 ? 's' : '' }} référent{{ selectedReferents.length > 1 ? 's' : '' }}
          v-list.py-0(two-line)
            v-list-tile.referent-contact(
              v-for="contact in selectedReferents"
              :key="contact.id"
              @click="$router.push({ name: 'client_contact_detail', params: { contactId: contact.id }})"
            )
              v-avatar.mr-3(size="60" style="filter: grayscale(100%);")
                v-img(alt="avatar" :src="contact.image_url" v-if="contact.image_url")
                v-icon(size="60" v-else color="grey lighten-1") account_circle
              v-layout.column
                v-layout
                  span.subheading {{ contact.first_name }} {{ contact.last_name }}
                  span.subheading(v-if="(contact.first_name || contact.last_name) && contact.function") : 
                  span.subheading.pl-1 {{ contact.function }}
                v-layout.justify-space-between
                  .body-1.grey--text.text--darken-1 {{ contact.user ? contact.user.login : '' }}
    v-layout.justify-center.pt-5(v-else)
      .subheading.font-italic.grey--text.text--darken-2 Il n'y a aucun produit rattaché à ce compte.
</template>

<script>
import RcTable from '@/components/RcTable/RcTable.vue';
import axios from 'axios';

export default {
  components: {
    RcTable,
  },
  data() {
    return {
      loading: false,
      clientId: this.$route.params.clientId,
      selectedProduct: null,
      referents: [],
      headers: [
        {
          label: 'Service',
          // sortable: true,
          overflow: 'newline',
          column: 'display_name',
          type: 'product_instance',
          width: '60%',
        },
        {
          label: "Date d'activation",
          type: 'date',
          // sortable: true,
          column: 'activation_date',
          width: '20%',
        },
        {
          label: 'Tarif',
          // sortable: true,
          column: 'price',
          width: '20%',
        },
      ],
      loaded: false,
    };
  },
  computed: {
    selectedReferents() {
      return this.referents.filter(referent => {
        return this.products[this.selectedProduct].some(product => product.referent_ids.includes(referent.id));
      });
    },
    isRc() {
      return this.$store.state.app.destination.id === 1;
    },
    parentProducts() {
      const clientProducts = this.$store.state.clients.products[this.clientId];
      let products = [];
      if (clientProducts) {
        products = clientProducts.map((it) => {
          const date = it.deactivation_date;
          const state = date && (Date.parse(date) - Date.parse(Date()) < 0) ? 'Désactivé' : 'Activé';
          return Object.assign({ state }, it);
        }).map(it => { return { id: it.product_id, name: it.product_name } });
        const a = products
          .filter((item, index) => products.findIndex(x => x.id === item.id) === index)
          .filter(it => this.setHierarchy(this.products[it.name]).length);
        return products
          .filter((item, index) => products.findIndex(x => x.id === item.id) === index)
          .filter(it => this.setHierarchy(this.products[it.name]).length)
          .sort((a, b) => a.name.localeCompare(b.name));
      }
      return [];
    },
    products: {
      get() {
        const clientProducts = JSON.parse(JSON.stringify(this.$store.state.clients.products[this.clientId]))
          .map(it => { it.price = it.price === 0 ? it.sale_ok ? 'Offert' : 'Gratuit' : `${this.formatCurr(it.price)} H.T./mois`; return it; });
        let products = [];
        if (clientProducts) {
          products = clientProducts.map((it) => {
            const date = it.deactivation_date;
            const state = date && (Date.parse(date) - Date.parse(Date()) < 0) ? 'Désactivé' : 'Activé';
            return Object.assign({ state }, it);
          }).reduce((obj, it) => {
            if (!obj[it.product_name]) {
              obj[it.product_name] = [];
            }
            obj[it.product_name].push(it);
            return obj;
          }, {});
        }
        return products;
      },
      set() {
      },
    },
  },
  methods: {
    getTotalPrice(product) {
      return JSON.parse(JSON.stringify(this.$store.state.clients.products[this.clientId]))
        .filter(it => product ? it.product_name === product : true)
        .reduce((acc, it) => {
          acc += it.price;
          return acc;
        }, 0);
    },
    formatCurr(price) {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price)
    },
    setHierarchy(products) {
      return products
        .map(it => {
          it.modules = it.sale_ok ? products.filter(x => parseInt(x.parent_id, 10) === it.id) : [];
          it.referent_ids = it.referent_ids.filter(x => x);
          return it;
        })
        .map(it => {
          it.child = !!(it.parent_id && products.find(y => y.id == it.parent_id && y.sale_ok))
          return it;
        })
        .filter(x => !x.child)
        .reduce((acc, it) => {
          acc.push(it);
          acc.push(...it.modules);
          return acc;
        }, [])
        .filter(it => !!it)
        .filter(product => product.sale_ok);
    },
    async getData() {
      if (this.clientId) {
        this.loading = true;
        try {
          await Promise.all([
            this.$store.dispatch('clients/getClientProducts', { clientId: this.clientId }),
            axios.get(`/v2/erp/clients/${this.clientId}/contacts?size=999&only_referents=true`),
          ]).then((values) => {
            this.referents = values[1].data.values;
          });
        } catch (error) {
          this.$store.dispatch('errorHandler/throwError', { title: "Une erreur s'est produite", detail: "Les services associés à ce compte n'ont pas pu être récupérée." });
        }
        this.loading = false;
      }
    },
    displayDate(date) {
      const displayDate = this.$moment(date).locale('fr').format('l');
      return displayDate === 'Invalid date' ? null : displayDate;
    },
  },
  mounted() {
    this.getData().then(() => {
      if (this.parentProducts[0]) {
        this.selectedProduct = this.parentProducts[0].name;
      }
      this.loaded = true;
    });
  },
};
</script>

<style lang="scss">
  .rc-products {
    .products-wrapper {
      max-height: 100%;
      .products-table {
        border-top: 1px solid #fafafa;
      }
    }
    .selected-product {
      background-color: var(--primary);
      color: white;
      .v-list__tile__sub-title {
        color: white;
      }
      transition: none;
    }
    .product-tile {
      transition: none;
      &:not(:last-of-type) {
        border-bottom: 1px solid lightgrey;
      }
    }
    .table-header {
      font-size: 16px!important;
    }
  }
  .referent-contact {
    border-top: 1px solid lightgrey;
    cursor: pointer;
    &:hover {
      background-color: #eee;
    }
  }
</style>
